import { tr } from "../../i18n";

/**
 * A dose on the ticket: a pod tank filled from an open bottle.
 *
 * Like a pack it takes a product's shape, so the ticket, its totals and the
 * receipt handle it unchanged; its own id keeps it a separate line from the
 * bottle itself. It moves no stock (the bottle left the shelf when it was
 * opened) and offers never touch it, which is why it carries no `offer`. The
 * server prices it again from the product's `dose_price`.
 */
export const DOSE_CATEGORY = "dose";

const DOSE_ID_PREFIX = "dose:";

export const isDoseItem = (item) => item?.category === DOSE_CATEGORY;

export const toDoseItem = ({ product_id: productId, id, name, dose_price: dosePrice, image }) => ({
  id: `${DOSE_ID_PREFIX}${productId || id}`,
  dose_product_id: productId || id,
  category: DOSE_CATEGORY,
  name: tr("doses.lineName", { name }),
  image: image || null,
  price: Number(dosePrice),
  unit_price: Number(dosePrice),
  discount_percentage: 0,
  offer: null,
  // Never limited by the shelf: the doses come out of a bottle already open
  stock_quantity: 9999,
});
